import axios from 'axios'

const baseUrl = process.env.REACT_APP_API_URL;

const updatingSingleImage = async (data) => {
  const token = JSON.parse(localStorage.getItem('user'))?.token

  const headingData = {
    coloum_name:data?.coloum_name,
    coloum_type:data?.coloum_type,
    picture:data?.picture,
    linkId:data?.link_id,
    userid:data?.user_id,
    description:data?.description,
    altDescription:data?.altDescription || "",
    url:data.url,
    optionId:data.optionId,
    language:data.language,
    }
  const path = `/api/user/updateImageBlock`
  const url = baseUrl + path
  const response = await axios.post(url, headingData,{
    headers: {
      'Content-Type': 'multipart/form-data',
      Authorization: `'Bearer'${token}`,
    },
  })
  return response.data
}


const updatingHeading = async (data) => {
  const token = JSON.parse(localStorage.getItem('user'))?.token
  const userID = JSON.parse(localStorage.getItem('user'))?.userid
  const optionId = data?.optionId
  const headingData = {
    coloum_value: data?.coloum_value,
    coloum_type: data?.coloum_type,
    coloum_name: data?.coloum_name,
    language : data?.language,
  }
  const path = `/api/user/updateBlock/${optionId}/${userID}/${token}`
  const url = baseUrl + path
  const response = await axios.put(url, headingData)
  return response.data
}

// update divider card

const updatingDivider = async (data) => {
  const token = JSON.parse(localStorage.getItem('user'))?.token
  const userID = JSON.parse(localStorage.getItem('user'))?.userid
  const optionId = data?.optionId
  const headingData = {
    coloum_value: data?.coloum_value,
    coloum_type: data?.coloum_type,
    coloum_name: data?.coloum_name,
    language : data?.language,
  }
  const path = `/api/user/updateBlock/${optionId}/${userID}/${token}`
  const url = baseUrl + path
  const response = await axios.put(url, headingData)
  return response.data
}

// _______________________Upating AvatarCard______________

const updatingAvatarCard = async (data) => {
  const token = JSON.parse(localStorage.getItem('user'))?.token
  const userID = JSON.parse(localStorage.getItem('user'))?.userid
  const avatarData = {
    coloum_name: data?.coloum_name,
    coloum_type: data?.coloum_type,
    radius: data?.radius,
    size: data?.size,
    picture: data?.picture,
    optionId: data?.optionId,
    linkId : data?.linkId,
    userid: userID,
    language: data?.language
  }
  // const postAvatarData = JSON.stringify(avatarData)
  const path = `/api/user/updateAvatarBlock`
  const url = baseUrl + path
  // const response = await axios.put(url, avatarData)
  const response = await axios.put(url, avatarData, {
    headers: {
      'Content-Type': 'multipart/form-data',
      Authorization: `'Bearer'${token}`,
    },
  })
  return response.data
}

const updatingSocialCard = async (data) => {
  const token = JSON.parse(localStorage.getItem('user'))?.token
  const userID = JSON.parse(localStorage.getItem('user'))?.userid
  const link_id = localStorage.getItem("linkId");
  const postdata = {
    columnName: data.columnName,
    emailState: data.emailState,
    phoneState: data.phoneState,
    facebookState: data?.facebookState,
    massengerState: data?.massengerState,
    instagramState: data?.instagramState,
    twitterState: data?.twitterState,
    tiktokState: data?.tiktokState,
    youtubeState: data?.youtubeState,
    soundcloudState: data?.soundcloudState,
    linkedinState: data?.linkedinState,
    spotifyState: data?.spotifyState,
    pinterestState: data?.pinterestState,
    twitchState: data?.twitchState,
    snapchatState: data?.snapchatState,
    telegramState: data?.telegramState,
    userID,
    link_id,
    optionid: data.optionid,
    language: data?.language,
  }
  const path = `/api/user/updateSocialBlock`
  const url = baseUrl + path
  const response = await axios.put(url, postdata, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `'Bearer'${token}`,
    },
    
  })
  return response.data
}

const updatingLinkCard = async (data) => {
  const token = JSON.parse(localStorage.getItem("user"))?.token;
  const userID = JSON.parse(localStorage.getItem("user"))?.userid;
  const optionId = data?.optionId;
  const headingData = {
    coloum_name: data?.coloum_name,
    coloum_type: data?.coloum_type,
    coloum_value:data?.coloum_value, 
    linkid: data?.linkId,
    userID,
    picture: data?.picture,
    prevIcon: data?.prevIcon,
    optionId,
    language: data?.language,
  };
  const path = `/api/user/updateLinkBlock/${optionId}/${userID}/${token}`;
  const url = baseUrl + path;
  const response = await axios.put(url, headingData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `'Bearer'${token}`,
    },
  });
  return response.data;
};

const updatingFaqCard = async (state) => {
  const linkId = localStorage.getItem('linkId')
  const userID = JSON.parse(localStorage.getItem('user')).userid

  console.log('state', state)

  const faqData = []

  if (state?.title_one || state?.description_one) {
    faqData.push({
      title: state?.title_one,
      description: state?.description_one,
    })
  }
  if (state?.title_two || state?.description_two) {
    faqData.push({
      title: state?.title_two,
      description: state?.description_two,
    })
  }
  if (state?.title_three || state?.description_three) {
    faqData.push({
      title: state?.title_three,
      description: state?.description_three,
    })
  }

  const coloumnValue = faqData
  const coloumnType = state?.coloum_type || null
  const columnName = state?.columnName
  const optionId = state?.optionId
  const language = state?.language

  const data = {
    columnName,
    coloumnType,
    coloumnValue,
    linkId,
    userID,
    optionId,
    language,
  }
  // const postData = JSON.stringify(data);
  const path = `/api/user/updateFaqBlock`
  const url = baseUrl + path
  const response = await axios.post(url, data)

  return response.data
}

const updatingYoutubeCard = async () => {}
const updatingTwitterCard = async () => {}
const updatingInstagramCard = async () => {}
const cardsService = {
  updatingHeading,
  updatingAvatarCard,
  updatingSocialCard,
  updatingLinkCard,
  updatingYoutubeCard,
  updatingTwitterCard,
  updatingInstagramCard,
  updatingFaqCard,
  updatingDivider,
  updatingSingleImage,
}
export default cardsService
